import MeetingRow from '../meetingRow';
import './style.scss';


function ItemsDescription({meetingGroups}) {

    const itemsDescription = [
        {
            name: 'Código de Proceso Formativo',
            code: 'ROL',
            value: 2
        },
        {
            name: 'Grupo',
            code: 'doc',
            value: 3
        },
        {
            name: 'Encuentro',
            code: 'nom',
            value: 4
        },
        {
            name: 'Mediador',
            code: 'cc',
            value: 5
        },
        {
            name: 'ID Encuentro',
            code: 'edi',
            value: 7
        },
        {
            name: 'Fecha',
            code: 'cont',
            value: 6
        },
        {
            name: 'Acciones',
            code: 'cont',
            value: 6
        }
    ];
    return (
        <div className='assistence-description-container'>
            <div className='description-container'>
                {itemsDescription.length > 0 &&
                    itemsDescription.map((itemD, i) => <p key={i}>{itemD.name}</p>)}
            </div>
            {meetingGroups?.meetingGroups.length > 0 &&
                meetingGroups?.meetingGroups.map((meetingGroup, i) => <MeetingRow key={meetingGroup?.id ?? i}
                                                                                  school ={meetingGroup?.school ?? meetingGroups?.school}
                                                                    meetingGroup={meetingGroup}/>)}
        </div>
    );
}

export default ItemsDescription;
